var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 49126",
    d: "M8.5 9.35156H3.5C2.83696 9.35156 2.20107 9.64291 1.73223 10.1615C1.26339 10.6801 1 11.3835 1 12.1169V13.4996H11V12.1169C11 11.7538 10.9353 11.3942 10.8097 11.0587C10.6841 10.7232 10.4999 10.4183 10.2678 10.1615C10.0356 9.90473 9.76002 9.70103 9.45671 9.56206C9.15339 9.42309 8.8283 9.35156 8.5 9.35156Z",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 49127",
    d: "M6 7.03072C6.49445 7.03072 6.9778 6.86853 7.38893 6.56467C7.80005 6.26081 8.12048 5.82892 8.3097 5.32362C8.49892 4.81831 8.54843 4.26229 8.45196 3.72587C8.3555 3.18944 8.1174 2.6967 7.76777 2.30996C7.41814 1.92321 6.97268 1.65984 6.48773 1.55314C6.00277 1.44643 5.50011 1.5012 5.04329 1.7105C4.58648 1.91981 4.19603 2.27425 3.92133 2.72901C3.64662 3.18377 3.5 3.71842 3.5 4.26536C3.5 4.99878 3.76339 5.70216 4.23223 6.22076C4.70107 6.73937 5.33696 7.03072 6 7.03072Z",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.d3272d66e9f349af33d1a1ac14924e80.svg";
export { ForwardRef as ReactComponent };